import classNames from 'classnames';

import { usePostContentContext } from '@/postContentElement/context';

import { genericEmbedHostContainer, genericEmbedHostParagraph } from './GenericEmbedHost.css';
import type { TPostGenericEmbedHostProps } from './GenericEmbedHost.types';

export const PostGenericEmbedHost = ({ element, children, editorMode }: TPostGenericEmbedHostProps) => {
  const { postTheme } = usePostContentContext();
  const textContent = element?.content?.[0]?.text;
  const isHidden = postTheme?.hyperlink_hide_link === 'true';

  if (!editorMode && (!textContent || isHidden)) return null;

  return (
    <div data-generic-embed-host className={classNames(genericEmbedHostContainer, editorMode && isHidden && 'hidden')}>
      <p className={genericEmbedHostParagraph}>{editorMode ? children : textContent}</p>
    </div>
  );
};
